import { useSocket } from "../lib/socket";
import type { User } from "../types";
import { ActivityDrawerProvider } from "./ActivityDrawer";
import { AppFrame } from "./AppFrame";
import { ViewSidebar } from "./ViewSidebar";

/**
 * The Helpdesk's shell: the shared app frame, with the ticket views in the
 * sidebar.
 *
 * The frame itself moved to `AppFrame` when the CRM was added -- the rail, the
 * phone drawer and the brand header belong to the platform, not to this
 * product, and the CRM renders in exactly the same one.
 *
 * The queue list that used to live here has moved inside the view: both layouts
 * render their own, and which tickets they show is now decided by the selected
 * view rather than by the channel in the URL.
 */
export function Shell({ user }: { user: User }) {
  const { connected } = useSocket();

  return (
    /*
     * The activity drawer wraps the whole frame rather than living inside a
     * screen: a company name is clickable from the list, from the details pane
     * and from the thread header, and all three want the same one panel.
     */
    <ActivityDrawerProvider>
      <AppFrame
        user={user}
        title="Helpdesk"
        connected={connected}
        sidebar={<ViewSidebar user={user} connected={connected} />}
      />
    </ActivityDrawerProvider>
  );
}
